(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function initPdpProof(root) {
    if (root.dataset.proofReady === 'true') return;

    var avatars = Array.from(root.querySelectorAll('[data-proof-avatar]'));
    var configNode = root.querySelector('[data-proof-config]');
    if (!avatars.length || !configNode) return;

    var config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      return;
    }

    root.dataset.proofReady = 'true';
    var order = avatars.slice();
    var motionDuration = 520;

    function advance() {
      var leaving = order[0];
      leaving.dataset.proofSlot = '-1';

      for (var index = 1; index < order.length; index += 1) {
        order[index].dataset.proofSlot = String(index - 1);
      }

      window.clearTimeout(root.proofResetTimer);
      root.proofResetTimer = window.setTimeout(function () {
        leaving.classList.add('is-resetting');
        leaving.dataset.proofSlot = String(order.length - 1);
        order.push(order.shift());

        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            leaving.classList.remove('is-resetting');
          });
        });
      }, motionDuration);
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    root.proofTimer = window.setInterval(function () {
      if (document.hidden) return;
      advance();
    }, Number(config.interval) || 5000);
  }

  function initAllPdpProofs(scope) {
    scope.querySelectorAll('[data-pdp-proof]').forEach(initPdpProof);
  }

  initAllPdpProofs(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAllPdpProofs(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-pdp-proof]').forEach(function (root) {
      window.clearInterval(root.proofTimer);
      window.clearTimeout(root.proofResetTimer);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
